import React, { useState } from "react";
import { Modal, Row, Col } from "react-bootstrap";
import {useForm} from "react-hook-form";
import axios from "axios";
import ReactTost from "../../ReactTost";
import { useTranslation } from "react-i18next";

const AddPlan = (props) => {
    const{handleSubmit, register, formState:{errors},reset,watch}=useForm();
    const [type, setType] = useState("");
    const [message, setMessage] = useState("");
    const [showAlert, setShowAlert] = useState(false);
    const API_URL = process.env.REACT_APP_API_URL;
    const API_VERSION = process.env.REACT_APP_API_VERSION;
    const {t} = useTranslation();

    const handleClose = () => {
      reset();
      props.onHide();
     
    };

    function savePlan(data) {
        if (
          data.name &&
          data.price &&
          data.position &&
          data.frequency &&
          data.bot &&
          data.storage &&
          data.question &&
          data.urlSize
        
        ) {
          
            axios
              .post(
                `${API_URL}/${API_VERSION}/plan`,
                {
                  name:data.name,
                  price:data.price,
                  duration:data.frequency,
                  maxBot:data.bot,
                  storage:data.storage,
                  maxMessage:data.question,
                  position:data.position,
                  maxUrlCount:data.urlSize,
                  isCustom:data.isCustom
                },
                {
                  headers: {
                    accept: "application/json",
                    Authorization: `Bearer ${localStorage.getItem("token")}`,
                  },
                }
              )
              .then((response) => {
                setType("Success");
                setMessage(t("Plan is added."));
                setShowAlert(true);
                props.getplans()
                reset();
                props.onHide();
              })
              .catch((error) => {
                setType("Danger");
                setMessage(
                  error.response.data.message
                    ? error.response.data.message
                    : t("Something went to wrong.")
                );
                setShowAlert(true);
              });
          }
        }
      
  return (
    <>
     <ReactTost
        onHide={() => {
          setShowAlert(false);
          setType("");
          setMessage("");
        }}
        alertClass={type}
        alertMessage={message}
        alertDo={showAlert}
      />
      <Modal
        {...props}
        size="md"
        aria-labelledby="contained-modal-title-vcenter"
        backdrop="static"
        centered
        onHide={handleClose}
      >
        <form onSubmit={handleSubmit(savePlan)}>
          <Modal.Header closeButton>
            <Modal.Title id="contained-modal-title-vcenter">
            {t("Add Plan")}
            </Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <Row>
              <Col md={12}>
                <div className="form-group mb-3">
                  <label htmlFor="">{t("Title")}</label>
                  <input
                    type="text"
                    className={`form-control ${errors.name ? 'is-invalid' : ''}`}
                    id="name"
                    name="name"
                    placeholder="Enter title here"
                    {...register('name',{required:"Name is required"})}
                  />
                  {errors.name && <div className="invalid-feedback">{errors.name.message}</div>}
                </div>
              </Col>

              <Col md={6}>
                <div className="form-group mb-3">
                  <label htmlFor="">{t("Position")}</label>
                  <input
                    type="number"
                    className={`form-control ${errors.position ? 'is-invalid' : ''}`}
                    id="position"
                    name="position"
                    placeholder="Enter position here"
                    {...register('position',{required:"position is required"})}
                  />
                  {errors.position && <div className="invalid-feedback">{errors.position.message}</div>}
                </div>
              </Col>

              <Col md={6}>
                <div className="form-group mb-3">
                  <label htmlFor="">{t("Price")}</label>
                  <input
                    type="number"
                    className={`form-control ${errors.price ? 'is-invalid' : ''}`}
                    id="price"
                    name="price"
                    placeholder="Enter price here"
                    {...register('price',{required:"price is required"})}
                    />
                    {errors.price && <div className="invalid-feedback">{errors.price.message}</div>}
                </div>
              </Col>

              <Col md={6}>
                <div className="form-group mb-3">
                  <label htmlFor="">{t("Frequency")}</label>
                  <select className={`form-select ${errors.frequency ? 'is-invalid' : ''}`} {...register('frequency',{required:"frequency is required"})} >
                    <option selected>{t("Choose frequency")}</option>
                    <option value="month">{t("Monthly")}</option>
                    <option value="year">{t("Yearly")}</option>
                  </select>
                  {errors.frequency && <div className="invalid-feedback">{errors.frequency.message}</div>}
                </div>
              </Col>

              <Col md={6}>
                <div className="form-group mb-3">
                  <label htmlFor="">{t("Bot limit")}</label>
                  <input
                    type="number"
                    className={`form-control ${errors.bot ? 'is-invalid' : ''}`}
                    id="botLimit"
                    name="botLimit"
                    placeholder="Bot limit"
                    {...register('bot',{required:"bot limit is required"})}
                    />
                  {errors.bot && <div className="invalid-feedback">{errors.bot.message}</div>}                
                </div>
              </Col>
          
              <Col md={6}>
                <div className="form-group mb-3">
                  <label htmlFor="">{t("Question limit")}</label>
                  <input
                    type="number"
                    className={`form-control ${errors.question ? 'is-invalid' : ''}`}
                    id="QuestionLimit"
                    name="QuestionLimit"
                    placeholder="Question limit"
                    {...register('question',{required:"question limit is required"})}
                    />
                    {errors.question && <div className="invalid-feedback">{errors.question.message}</div>}
                    
                  
                </div>
              </Col>
              <Col md={6}>
                <div className="form-group mb-3">
                  <label htmlFor="">{t("Storage Size")}</label>
                  <input
                    type="number"
                    className={`form-control ${errors.storage ? 'is-invalid' : ''}`}
                    id="fileSize"
                    name="fileSize"
                    placeholder="Storage size limit"
                    {...register('storage',{required:"storage limit is required"})}
                  />
                  {errors.storage && <div className="invalid-feedback">{errors.storage.message}</div>}
                </div>
              </Col>
              <Col md={6}>
                <div className="form-group mb-3">
                  <label htmlFor="">{t("URL Count")}</label>
                  <input
                    type="number"
                    className={`form-control ${errors.urlSize ? 'is-invalid' : ''}`}
                    id="urlSize"
                    name="urlSize"
                    placeholder="Enter URL count"
                    {...register('urlSize',{required:"URL count is required"})}
                  />
                  {errors.urlSize && <div className="invalid-feedback">{errors.urlSize.message}</div>}
                </div>
              </Col>
              <Col md={6}>
                <div className="form-group d-flex gap-2 align-items-center">
                  <label htmlFor="isCustom">{t("Plan is custom")}</label>
                  <input
                    type="checkbox"
                    className="form-check-input"
                    id="isCustom"
                    name="isCustom"
                    {...register('isCustom')}
                  />
                </div>
              </Col>
            </Row>
          </Modal.Body>
          <Modal.Footer>
            <input
              type="submit"
              value="Save"
              className="userbutton mt-3"
            />
          </Modal.Footer>
        </form>
      </Modal>
    </>
  );
};

export default AddPlan;
